import { render } from "./SharedPage.vue?vue&type=template&id=f7c85244&scoped=true&ts=true"
import script from "./SharedPage.vue?vue&type=script&lang=ts"
export * from "./SharedPage.vue?vue&type=script&lang=ts"

import "./SharedPage.vue?vue&type=style&index=0&id=f7c85244&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c85244"]])

export default __exports__